import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { ITeamSkillMast } from "../../models/ISkillTeamManagement";
import { ITeamMast } from "./Table";
import { ILogin } from "../../models/Login";
import { IUserMast } from "../../models/UserMast";
import { Dialog } from "primereact/dialog";
import { AttendanceHistoryTable } from "../attendanceMark/Table";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface IProps {
    toast?: any,
    filters?: any,
    team_id?: number,
    user_ID?:number,
    open?: boolean
}

export const SkillHistoryTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [attendanceTable, setAttendanceTable] = useState({ user_id: 0, open: false } as { user_id: number, open: boolean });

    const dt = useRef<any>();
    

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const onHideHistoryTable = () => {
        setAttendanceTable({ user_id: 0, open: false });
        console.log(attendanceTable);
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0"></h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                {/* <Search setSearch={setGlobalFilter} /> */}
            </span>
        </div>
    );

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Team_Skill_Mast/skillHistoryTable", "GET", null, `team_id=${props.team_id}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const toggleVal = async (login_id: number, toggle_type: number) => {
        const response = await Fetch("User_Mast/toggle", "PUT", null, `login_id=${login_id}&toggle_type=${toggle_type}`, props.toast);
        if (response) {
            // let message: string = toggle_type === 1 ? "User Status Changed" : toggle_type === 2 ? "Temp Status Changed" : "Work From Changed";
            let message: string = "User Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };

    const user_TStatus = (rowData: IUserMast) => {
        return (
            <span style={{ color: rowData.temp_Inactive ? 'red' : 'green' }} className="cursor-pointer" onClick={() => { if (rowData.login_ID && (_roles.includes(1) || _roles.includes(4)))  toggleVal(rowData.login_ID, 2); console.log("prokpk"); }}>{rowData.temp_Inactive ? "No" : "Yes"}</span>
        );

    };

    useEffect(() => {
        loadTableData();
    }, [props.open])


const DateFormat = loginObj.date_Format;

    return (
        <>
        <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
            ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
            emptyMessage="No Branches found."
            header={header}
            loading={tableData.loading}
            value={tableData.tableData}
        >
            <Column field="team_Member" header="Team Member" />
            <Column field="updated_By_Name" header="Updated By" />
            {/* <Column field="date" header="Date" body={(e) => <p>{e.date.split("T")[0]}{" | "}{(Number(e.date.split("T")[1].split(":")[0]) <= 12 ? Number(e.date.split("T")[1].split(":")[0]) : Number(e.date.split("T")[1].split(":")[0]) - 12) + ":" + e.date.split("T")[1].split(":")[1]} {Number(e.date.split("T")[1].split(":")[0]) < 12 ? "AM" : "PM"}</p>} /> */}
            <Column field="date" header="Date" body={(rowData: any) => safeFormatDate(rowData.date, 'dd/MM/yyyy HH:mm', DateFormat, )}/>
            <Column field="action" header="Action" />
            <Column field="temp_Inactive" header="Present" body={user_TStatus} />
            <Column field="user_Status" header="Status" body={(rowData) => <span style={{ color: rowData.user_Status ? 'red' : 'green' }}>{rowData.user_Status ? "Inactive" : "Active"}</span>} />
            <Column field="" header="History" body={(rowData) => <i className="cursor-pointer text-primary pi pi-history" onClick={() => setAttendanceTable({ user_id: rowData.login_ID, open: true })}></i>} />
           
        </DataTable>
        <Dialog visible={attendanceTable.open} style={{ width: '80vw' }} header="Present Absent History" modal className="p-fluid" onHide={onHideHistoryTable} >
         <AttendanceHistoryTable user_ID={attendanceTable.user_id} />
     </Dialog>
        </>
       
    );
}